module.exports = __webpack_public_path__ + "static/media/hiltonhead.1615907a.jpg";